export default "__VITE_ASSET__DdSJeRQ3__"